// Side-effect: aplica el runtime (prod/dev) elegido en el login sobre `window.__env`.
// Debe ser el PRIMER import de main.ts — ver runtime-selector.ts.
import { applyStoredRuntime } from './runtime-selector';

applyStoredRuntime();
